export default "__VITE_ASSET__BxxzV8k$__"